export default "__VITE_ASSET__nbO7pvi5__"